import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './components/login/auth.interceptor';
import { LoginModule } from './components/login/login.module';
import { PrimeiroAcessoUsuarioModule } from './components/usuario/primeiro-acesso-usuario.module';
import { PrimeiroAcessoComponent } from './components/usuario/primeiro-acesso/primeiro-acesso.component';
import { UsuarioService } from './components/usuario/service/usuario.service';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import {  MatCardModule, MatDialogModule, MatRadioModule } from '@angular/material';

registerLocaleData(localePt);
@NgModule({
  declarations: [
    AppComponent,
    PrimeiroAcessoComponent,
  ],
  imports: [
    CoreModule,
    AppRoutingModule,
    LoginModule,
    PrimeiroAcessoUsuarioModule,
    SharedModule,
    MatDialogModule,
    MatCardModule,
  ],
  providers: [
    UsuarioService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    CookieService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
